module.exports = __webpack_public_path__ + "static/img/photo04.aff2004.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Hakodate/photo04.jpg
// module id = 1g3r
// module chunks = 0